import React, { useEffect, useState } from "react";
import { Grid, IconButton, LinearProgress, Typography } from "@material-ui/core";
import { RaceEntryOverviewStartGroup, RaceEntryOverviewStartGroupDetailCompany } from "../../../../model/RaceEntryOverview";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { ApiBackend } from "../../../../providers/apibackend";
import { RouteComponentProps, withRouter } from "react-router";
import EntryStatItemDetails from "./EntryStatItemDetails";
import { undefinedNumberFormatter } from "./utils";

type Props = {
    raceId: string;
    group: RaceEntryOverviewStartGroup;
};

const EntryStatItem = (props: Props & RouteComponentProps) => {
    const [data, setData] = useState<RaceEntryOverviewStartGroupDetailCompany[]>(null);
    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const api = new ApiBackend();

    useEffect(() => {
        if (!expanded) {
            return;
        }

        fetchData();

    }, [expanded]);

    const hasCalcValues = () => {
        const { group } = props;

        return group.maxParticipants !== undefined && group.numParticipants !== undefined && group.numReserved !== undefined;
    };

    const render = () => {
        const { group } = props;

        const itemStyle = { paddingBottom: 0, paddingTop: 0 };

        return (<>
            <Grid item xs={2} style={itemStyle}>
                <IconButton size="small" onClick={handleExpandClick}>
                    {expanded ? (
                        <KeyboardArrowUp />
                    ) : (
                        <KeyboardArrowDown />
                    )}
                </IconButton>
                {group.name}
            </Grid>
            <Grid item xs={2} style={itemStyle}>
                <b>{undefinedNumberFormatter(group.maxParticipants)}</b>
            </Grid>
            <Grid item xs={2} style={itemStyle}>
                <b>{undefinedNumberFormatter(group.numSellable)}</b>
            </Grid>
            <Grid item xs={2} style={itemStyle}>
                <b>{undefinedNumberFormatter(group.numParticipants)}</b>
            </Grid>
            <Grid item xs={1} style={itemStyle}>
                <b>{undefinedNumberFormatter(group.numReserved)}</b>
            </Grid>
            <Grid item xs={1} style={itemStyle}>
                <b>{undefinedNumberFormatter(group.numCompanyReserved)}</b>
            </Grid>
            <Grid item xs={1} style={itemStyle}>
                <b>{hasCalcValues() ? group.maxParticipants - group.numParticipants - group.numReserved : ""}</b>
            </Grid>
            <Grid item xs={1} style={itemStyle}>
                <b>{undefinedNumberFormatter(group.numFreePlaces)}</b>
            </Grid>
            {expanded && (
                <Grid item xs={12}>
                    {renderDetails()}
                </Grid>
            )}
        </>);
    };

    const renderDetails = () => {
        const { raceId, group } = props;

        return (
            <Grid container style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Grid item xs={4} style={{ fontWeight: "bold", paddingLeft: "10px" }}>
                    <Typography variant="body2" style={{ fontWeight: "bold" }}>Företag</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontWeight: "bold" }}>
                    <Typography variant="body2" style={{ fontWeight: "bold" }}>Antal deltagare</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontWeight: "bold" }}>
                    <Typography variant="body2" style={{ fontWeight: "bold" }}>Antal otilldelade</Typography>
                </Grid>

                {loading &&
                    <Grid item xs={12}>
                        <LinearProgress color="secondary" />
                    </Grid>
                }

                {data && data.map((item, idx) => {
                    return (
                        <Grid key={idx} item xs={12} style={{ backgroundColor: idx % 2 ? "#efefef" : "unset" }}>
                            <Grid container>
                                <EntryStatItemDetails key={idx} raceId={raceId} group={group} item={item} />
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        );
        // return (
        //     <Grid container style={{ paddingLeft: 20, paddingRight: 20 }}>
        //         <Grid item xs={6}>
        //             <EnhancedTable<RaceEntryOverviewStartGroupDetailCompany>
        //                 columnDefinitions={columnDefinitions}
        //                 data={data ?? []}
        //                 loading={loading}
        //                 dense
        //                 noPagination
        //                 noSort
        //             />
        //         </Grid>
        //     </Grid>
        // )
    };

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const fetchData = async () => {
        const { raceId, group } = props;

        setLoading(true);

        try {
            const details = await api.getEntryOverviewDetails(raceId, group.id);
            setData(details?.items);
        } finally {
            setLoading(false);
        }
    };

    return render();
};

export default withRouter(EntryStatItem);
